import { createApp } from 'vue';
import { createRouter, createWebHistory } from 'vue-router';
import App from './App.vue';

import Survey from './components/Survey.vue';
import Admin from './components/Admin.vue';
import End from './components/End.vue';
import Home from './components/Home.vue';
import Management from './components/Management.vue';
import Edit from './components/Edit.vue';
import Delete from './components/Delete.vue';
import Add from './components/Add.vue';
import AddScale from './components/AddScale.vue';
import DeleteScale from './components/DeleteScale.vue';
import Qr from './components/Qr.vue';

const routes = [
  { path: '/', component: Home },
  { path: '/admin', component: Admin },
  { path: '/manage', component: Management },
  { path: '/add', component: Add },
  { path: '/addScale', component: AddScale },
  { path: '/edit/:code', component: Edit },
  { path: '/delete/:code', component: Delete },
  { path: '/deleteScale/:id', component: DeleteScale },
  { path: '/end', component: End },
  { path: '/:code/qr', component: Qr },
  { path: '/:code', component: Survey },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

createApp(App)
  .use(router)
  .mount('#app');
